<template>
  <div
    v-if="activeStory && (referencedArt ? referencedArt.length > 0 : false)"
    class="frow column-start width-100 reference-stories"
  >
    <strong @click="showArtLinks = !showArtLinks">
      <i
        class="icon"
        :class="showArtLinks ? 'ion-md-arrow-dropup' :'ion-md-arrow-dropdown'"
      />
      art referenced in this story
    </strong>
    <ul v-if="showArtLinks">
      <li
        v-for="a in referencedArt"
        :key="`ref-${art}`"
      >
        <span>
          {{ a }}
        </span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'ArtReferences',
  props: {
    activeStory: {
      type: Object,
      default: () => {}, 
    },
    art: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showArtLinks: false,
    };
  },
  computed: {
    referencedArt() {
      let matchedLinks = this.activeStory.description.match(/<a(.*?)a>/g);
      let sanatizedLinks = [];
      if (matchedLinks) {
        matchedLinks.forEach((link) => {
        // console.log(`${link.match(/href=".*?#art-(.*?)"/)[1]}`);
        // console.log(`Link: ${link}`);
        // console.log(`${this.getArtTitleById(link.match(/href=".*?#art-(.*?)"/))}`);
          let id = link.match(/href=".*?#art-(.*?)"/) ? link.match(/href=".*?#art-(.*?)"/)[1] : null;
          if (id) {
            sanatizedLinks.push(
              `${link.match(/>(.*?)</)[1]} -> ${this.getArtTitleById(id)}`,
            );
          }
        });
      }
      return sanatizedLinks;
    },
  },
  methods: {
    getArtTitleById(id) {
      return this.art.find((art) => art.id == id).title;
    },
  },
};
</script>
<style scoped lang="scss">
.reference-stories {
  min-height: 100px;
  text-align: left;
}
strong {
  cursor: pointer;
  display: flex;
}
i {
  font-size: 25px;
  margin-left: -5px;
}
</style>
